import {gsap} from "../LibrariesImport";

export default class BlockScrollingText {
	static init() {

		document.querySelectorAll(".block-scrolling-text .scrolling-text").forEach(scrollingText => {
			setTimeout(() => {
				const a = scrollingText.querySelector(".text");
				const width = a.scrollWidth;
				const tl = gsap.timeline({repeat: -1});
				const multiplier = window.innerWidth > 767 ? 20 : 10;
				tl.to(scrollingText, {
					x: -width + "px",
					ease: "none",
					duration: (width / window.innerWidth) * multiplier
				});
			});
		});

	}

}
